/* eslint-disable import/prefer-default-export */
import { ISendToState } from '.'
import { RootStore } from '../store'

export const selectSendTo = (state: RootStore): ISendToState => state.sendTo
